import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=8e493ec4&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=8e493ec4&prod&lang=scss&scoped=true"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&id=8e493ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e493ec4",
  null
  
)

export default component.exports